const mainSteps = [
	{
		title: 'Create a wallet',
		description:
			'This will be how you interact with the Giveth platform and transfer funds.',
		element: (
			<iframe
				width='100%'
				height='100%'
				src='https://www.youtube.com/embed/TLlebSlRDyo?si=XbudLLSHbjRPK1_c'
				title='YouTube video player'
				frameBorder='0'
				allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
				allowFullScreen
			/>
		),
	},
	{
		title: 'Create your account on Giveth',
		description:
			'Once you have a wallet on your browser, click the “SIGN IN” button on the upper right of the Giveth site and choose “Sign in with Ethereum”.',
		element: (
			<iframe
				width='100%'
				height='100%'
				src='https://www.youtube.com/embed/sOtvDCAqV88?si=ohQ7JXG7DBgNnGim'
				title='YouTube video player'
				frameBorder='0'
				allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
				allowFullScreen
			/>
		),
	},
	{
		title: 'Fund your wallet with crypto',
		description:
			'Once you create an account on Giveth and sign in with your browser wallet, the next step is to fund your wallet with some crypto currency.',
		element: (
			<iframe
				width='100%'
				height='100%'
				src='https://www.youtube.com/embed/O-Vq7i4FqOw?si=cwQWSBN2-Gjy4T41'
				title='YouTube video player'
				frameBorder='0'
				allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
				allowFullScreen
			/>
		),
	},
];

export default mainSteps;
